<div class="field-activity-header" #parent [ngStyle]="{ width: config.width, height: config.height }">
  <div class="container" [ngStyle]="{ left: positionHeader + '%' }">
    <div
      #child
      class="header"
      [ngStyle]="{
        'grid-template-columns': 'repeat(' + headers.length + ', 1fr)',
        width: width
      }"
    >
      <div *ngFor="let header of headers; let i = index">
        <div class="header-title" [class.hidden]="shouldHideHeader(i)">
          <ng-container *ngIf="!header.isIcon; else iconBlock">
            <div class="title">{{ header.label }}</div>
          </ng-container>
          <ng-template #iconBlock>
            <img class="icon" [src]="'assets/icons/' + header.label + '.svg'" alt="{{ header.label }}" />
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <!-- Pinned day header -->
  <div #pinnedElRef class="pinned-day-header" *ngIf="pinnedHeader">
    <div class="title">{{ pinnedHeader.label }}</div>
  </div>
</div>
